import Marquee from "react-fast-marquee";

const WORDS = [
  "Resume Writing", "LinkedIn Optimisation", "Interview Coaching", "Career Roadmap",
  "Career Transition Programme", "Personal Branding", "Job Search Strategy",
  "Recruitment", "RPO", "Talent Acquisition", "Business Development & Lead Generation",
  "Hiring Strategy & Workforce Planning", "HR & Payroll",
];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee-section" className="bg-[#142A5E] py-8 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="px-6 font-display text-xl md:text-2xl font-extrabold tracking-tight text-white/95">
              {w}
            </span>
            <span className="text-[#2FA86A] text-xl md:text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
